import { FontCategory } from '@quicktools/shared-components/data/fonts';
import { memo, useEffect, useState } from 'react';
import Link from 'next/link';
import cls from 'classnames';

import { Category } from '../../types';
import analytics from '../../services/analytics';

import useStyles from './styles';
import { CategoryProps } from './types';

function getIdByCategory(id: FontCategory) {
  return `cat-${id}`;
}

function MobileCategories({ selected, categories }: CategoryProps) {
  const styles = useStyles();
  const [lastElementWidth, setLastElementWidth] = useState(120);

  const onItemClick = (category_name: string, page_name: string) => {
    analytics.gaEvent('category_select', {
      page_name,
      category_name,
    });
  };

  useEffect(() => {
    const isFirstElement = selected === categories[0];

    if (!isFirstElement) {
      const id = getIdByCategory(selected.id);
      const elem = document.getElementById(id);

      elem &&
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
    }
    setLastElementWidth(16);
  }, []);

  return (
    <div className={styles.root}>
      {categories.map((current: Category) => {
        const { text, href, Icon, pageName } = current;

        return (
          <Link href={href} passHref={true} key={text}>
            <a
              onClick={() => onItemClick(text, pageName)}
              className={cls(styles.entry, selected === current && styles.entrySelected)}
              key={text}
              id={getIdByCategory(current.id)}
            >
              {Icon && <Icon className={styles.icon} />}
              <span className={styles.text}>{text}</span>
            </a>
          </Link>
        );
      })}
      {/*
         :last-child is weird in Safari:
         https://stackoverflow.com/questions/75214334/margin-right-on-last-child-isnt-working-in-safari
         Also in order to scroll to last element we use a hack which requires resetting the width.
       */}
      <div style={{ minWidth: lastElementWidth }}></div>
    </div>
  );
}

export default memo(MobileCategories);
